export class Pair<T, R> {

    constructor(
        public x: T,
        public y: R,
    ) { }
}
